// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"BlurbConsent_checkboxes__3FpxQ","disagreeMessage":"BlurbConsent_disagreeMessage__DszGp","disagreeMessageVisible":"BlurbConsent_disagreeMessageVisible__2pnGt"};